// Computes the Firestore doc id for a criteria/qualifier/disqualifier exclusion
// config. Criteria keep the raw field name for backward-compatibility with
// configs saved before qualifier/disqualifier support existed; the newer groups
// are namespaced so a qualifier or disqualifier can never collide with a
// criteria — or each other — that happens to share a field name.
const getExclusionConfigDocId = ({
  fieldType,
  fieldName,
}: {
  fieldType: BonusRecordTagging.FieldType;
  fieldName: string;
}): string =>
  fieldType === 'criteria' ? fieldName : `${fieldType}:${fieldName}`;

export default getExclusionConfigDocId;
